import { render, staticRenderFns } from "./FormSpinbuttonDisabledReadonly.vue?vue&type=template&id=1bf3fc5c&"
import script from "./FormSpinbuttonDisabledReadonly.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonDisabledReadonly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports